// src/data/ordinaryStampData.js

import ordinary1 from "../assets/ordinarystamp/ordinary1.jpg";
import ordinary2 from "../assets/ordinarystamp/ordinary2.jpg";
import ordinary3 from "../assets/ordinarystamp/ordinary3.jpg";
import ordinary4 from "../assets/ordinarystamp/ordinary4.jfif";

const ordinaryStampData = [
  {
    id: 1,
    name: "Ordinary Stamp",
    category: "Ordinary",
    image: ordinary1,
    size: "45x15 mm",
    description: "Classic rectangular wax stamp, ideal for sealing envelopes or documents with a refined touch.",
  },
  {
    id: 2,
    name: "Ordinary Stamp (Medium & Small Sizes)",
    category: "Ordinary",
    image: ordinary2,
    size: "All Sizes",
    description: "Versatile wax stamp suitable for multiple mediums; perfect for decorative seals and premium stationery.",
  },
  {
    id: 3,
    name: "Ordinary Stamp",
    category: "Ordinary",
    image: ordinary3,
    size: "40x40 mm",
    description: "Elegant round wax stamp designed for invitations, packaging, and personalized seals with a professional finish.",
  },
  {
    id: 4,
    name: "Ordinary Stamp",
    category: "Ordinary",
    image: ordinary4,
    size: "All sizes",
    description: "Standard rectangular wax stamp, perfect for everyday use in offices or at home.",
  }
];

export default ordinaryStampData;
